import { render } from "./PublicFiles.vue?vue&type=template&id=7f5f72f6"
import script from "./PublicFiles.vue?vue&type=script&lang=js"
export * from "./PublicFiles.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\ef_vue_icecreator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__